import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/regenerator/index.js";
import { useEffect } from 'react';
import { checkQuizVisibility } from '../../../utils/check-quiz-visibility';
import { fetchQuizIndexData } from '../../../utils/fetch-quiz-index-data';
import { openQuiz } from '../../open-quiz-modal/open-quiz-modal';
import { checkConditions } from './check-conditions';
var DEFAULT_SESSION_VALUE = 'UXS_session_value';
/** Контролирует наличие квиза на странице, проверяет условия его показа и отправляет ивент об открытии */
export function useQuizTriggers(props) {
  var url = props.url,
    user = props.user,
    _props$sessionSeconds = props.sessionSecondsPassedKey,
    sessionSecondsPassedKey = _props$sessionSeconds === void 0 ? DEFAULT_SESSION_VALUE : _props$sessionSeconds,
    _props$environment = props.environment,
    environment = _props$environment === void 0 ? 'production' : _props$environment;
  var userCurrentRoleType = user === null || user === void 0 ? void 0 : user.currentRoleType;
  var userId = user === null || user === void 0 ? void 0 : user.userId;
  useEffect(function () {
    var timeout;
    function findQuizData() {
      return _findQuizData.apply(this, arguments);
    }
    function _findQuizData() {
      _findQuizData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var key, quizIndexData, foundQuizData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              key = "".concat(userId, "_").concat(url);
              _context.next = 3;
              return fetchQuizIndexData({
                environment: environment,
                key: key
              });
            case 3:
              quizIndexData = _context.sent;
              foundQuizData = quizIndexData.find(function (_ref) {
                var conditions = _ref.conditions;
                return checkConditions({
                  conditions: conditions,
                  url: url,
                  userCurrentRoleType: userCurrentRoleType
                });
              });
              _context.t0 = !foundQuizData;
              if (_context.t0) {
                _context.next = 10;
                break;
              }
              _context.next = 9;
              return checkQuizVisibility({
                quizId: foundQuizData.id,
                userId: userId
              });
            case 9:
              _context.t0 = !_context.sent;
            case 10:
              if (!_context.t0) {
                _context.next = 12;
                break;
              }
              return _context.abrupt("return");
            case 12:
              timeout = sendEventOpenQuiz({
                quizData: foundQuizData,
                sessionSecondsPassedKey: sessionSecondsPassedKey
              });
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _findQuizData.apply(this, arguments);
    }
    findQuizData();
    return function () {
      clearTimeout(timeout);
    };
  }, [url, userCurrentRoleType, userId, sessionSecondsPassedKey, environment]);
}
function sendEventOpenQuiz(_ref2) {
  var quizData = _ref2.quizData,
    sessionSecondsPassedKey = _ref2.sessionSecondsPassedKey;
  var eventData = _objectSpread({
    id: quizData.id
  }, quizData.props);
  var timeout;
  if (!quizData.conditions.sessionTimeout) {
    openQuiz(eventData);
    return timeout;
  }
  var sessionTimeoutMilliseconds = quizData.conditions.sessionTimeout * 1000;
  var sessionMillisecondsPassed = quizData.conditions.isPageSessionTimeout ? 0 : +sessionStorage.getItem(sessionSecondsPassedKey) * 1000;
  if (sessionTimeoutMilliseconds > sessionMillisecondsPassed) {
    timeout = setTimeout(function () {
      openQuiz(eventData);
    }, sessionTimeoutMilliseconds - sessionMillisecondsPassed);
  } else {
    openQuiz(eventData);
  }
  return timeout;
}